// extracted by mini-css-extract-plugin
module.exports = {"emptyCharts":"jHXqJxCR","emptyImg":"vLv5oq0_"};